export default __webpack_public_path__ + "static/media/g-uni-to-arrakis.98b832c3.svg";